import React, { Component } from 'react';
import { Bar, Line } from 'react-chartjs-2';
import { Dropdown, DropdownMenu, DropdownItem, Progress } from 'reactstrap';
import PricingTable from './pricingTables'

var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);



const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandDanger = '#f86c6b';

const textoChico = {
    backgroundColor: "#CCC",
    color: "#ccc",
    width: "15%",
    height: "15%",
    marginTop: "1px"
}

const textoGrande = {
    backgroundColor: "#CCC",
    color: "#ccc",
    width: "70%",
    height: "15%",
    marginTop: "1px"
}


// Card Chart 1
const cardChartData1 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: brandPrimary,
            borderColor: 'rgba(255,255,255,.55)',
            data: [65, 59, 84, 84, 51, 55, 40]
        }
    ],
};

const cardChartOpts1 = {
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    scales: {
        xAxes: [{
            gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
            },
            ticks: {
                fontSize: 2,
                fontColor: 'transparent',
            }

        }],
        yAxes: [{
            display: false,
            ticks: {
                display: false,
                min: Math.min.apply(Math, cardChartData1.datasets[0].data) - 5,
                max: Math.max.apply(Math, cardChartData1.datasets[0].data) + 5,
            }
        }],
    },
    elements: {
        line: {
            borderWidth: 1
        },
        point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4,
        },
    }
}

// Card Chart 2
const cardChartData2 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: brandInfo,
            borderColor: 'rgba(255,255,255,.55)',
            data: [1, 18, 9, 17, 34, 22, 11]
        }
    ],
};

const cardChartOpts2 = {
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    scales: {
        xAxes: [{
            gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
            },
            ticks: {
                fontSize: 2,
                fontColor: 'transparent',
            }

        }],
        yAxes: [{
            display: false,
            ticks: {
                display: false,
                min: Math.min.apply(Math, cardChartData2.datasets[0].data) - 5,
                max: Math.max.apply(Math, cardChartData2.datasets[0].data) + 5,
            }
        }],
    },
    elements: {
        line: {
            tension: 0.00001,
            borderWidth: 1
        },
        point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4,
        },
    }
}

// Card Chart 3
const cardChartData3 = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: 'rgba(255,255,255,.2)',
            borderColor: 'rgba(255,255,255,.55)',
            data: [78, 81, 80, 45, 34, 12, 40]
        }
    ],
};

const cardChartOpts3 = {
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    scales: {
        xAxes: [{
            display: false
        }],
        yAxes: [{
            display: false
        }],
    },
    elements: {
        line: {
            borderWidth: 2
        },
        point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
        },
    }
}

// Card Chart 4
const cardChartData4 = {
    labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: 'rgba(255,255,255,.3)',
            borderColor: 'transparent',
            data: [78, 81, 80, 45, 34, 12, 40, 75, 34, 89, 32, 68, 54, 72, 18, 98]
        }
    ],
};

const cardChartOpts4 = {
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    scales: {
        xAxes: [{
            display: false,
            barPercentage: 0.6,
        }],
        yAxes: [{
            display: false,
        }]
    }
}

// Main Chart

// convert Hex to RGBA
function convertHex(hex, opacity) {
    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);

    var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
    return result;
}

//Random Numbers
function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

var elements = 27;
var data1 = [];
var data2 = [];
var data3 = [];

for (var i = 0; i <= elements; i++) {
    data1.push(random(50, 200));
    data2.push(random(80, 100));
    data3.push(65);
}

const mainChart = {
    labels: ['L', 'M', 'M', 'J', 'V', 'S', 'D', 'L', 'M', 'M', 'J', 'V', 'S', 'D', 'L', 'M', 'M', 'J', 'V', 'S', 'D', 'L', 'M', 'M', 'J', 'V', 'S', 'D'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: convertHex(brandInfo, 10),
            borderColor: brandInfo,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: data1
        },
        {
            label: 'My Second dataset',
            backgroundColor: 'transparent',
            borderColor: brandSuccess,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: data2
        },
        {
            label: 'My Third dataset',
            backgroundColor: 'transparent',
            borderColor: brandDanger,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            borderDash: [8, 5],
            data: data3
        }
    ]
}

const mainChartOpts = {
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    scales: {
        xAxes: [{
            gridLines: {
                drawOnChartArea: false,
            }
        }],
        yAxes: [{
            ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(250 / 5),
                max: 250
            }
        }]
    },
    elements: {
        point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
        }
    }
}

class MockUp extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            año: "",
            mes: "",
            meses : ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }


    componentWillMount() {
        var d = new Date()
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        this.setState({ mes: mm -1, año: yyyy });
    };

    render() {
        return (
            <div className="animated fadeIn">
                <div style={{ position: "absolute", left: "0", right: "0", top: "30%", zIndex: "1" }}>
                    <PricingTable />
                </div>
                <div className="row">
                    <ToastContainer
                        style={{ top: "60" }}
                        ref="container"
                        toastMessageFactory={ToastMessageFactory}
                        className="toast-top-right"
                    />
                    <div className="col-sm-6 col-lg-3">
                        <div className="card card-inverse card-primary">
                            <div className="card-block pb-0">
                                <div className="btn-group float-right">
                                    <Dropdown isOpen={this.state.card1} toggle={() => { this.setState({ card1: !this.state.card1 }); }}>
                                        <button onClick={() => { this.setState({ card1: !this.state.card1 }); }} className="btn btn-transparent active dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.card1}>
                                            <i className="icon-settings"></i>
                                        </button>
                                        <DropdownMenu>
                                            <DropdownItem>Action</DropdownItem>
                                            <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                                <h4 className="mb-0">823</h4>
                                <p>Usuarios Activos</p>
                            </div>
                            <div className="chart-wrapper px-3">
                                <Line data={cardChartData1} options={cardChartOpts1} height={70} />
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-3">
                        <div className="card card-inverse card-info">
                            <div className="card-block pb-0">
                                <div className="btn-group float-right">
                                    <Dropdown isOpen={this.state.card2} toggle={() => { this.setState({ card2: !this.state.card2 }); }}>
                                        <button onClick={() => { this.setState({ card2: !this.state.card2 }); }} className="btn btn-transparent active dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.card2}>
                                            <i className="icon-settings"></i>
                                        </button>
                                        <DropdownMenu>
                                            <DropdownItem>Action</DropdownItem>
                                            <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                                <h4 className="mb-0" >93</h4>
                                <p >Visistas realizadas</p>
                            </div>
                            <div className="chart-wrapper px-3">
                                <Line data={cardChartData2} options={cardChartOpts2} height={70} />
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-3">
                        <div className="card card-inverse card-warning">
                            <div className="card-block pb-0">
                                <div className="btn-group float-right">
                                    <Dropdown isOpen={this.state.card3} toggle={() => { this.setState({ card3: !this.state.card3 }); }}>
                                        <button onClick={() => { this.setState({ card3: !this.state.card3 }); }} className="btn btn-transparent active dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.card3}>
                                            <i className="icon-settings"></i>
                                        </button>
                                        <DropdownMenu>
                                            <DropdownItem>Action</DropdownItem>
                                            <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                                <h4 className="mb-0" >12</h4>
                                <p >Merma</p>
                            </div>
                            <div className="chart-wrapper">
                                <Line data={cardChartData3} options={cardChartOpts3} height={70} />
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-3">
                        <div className="card card-inverse card-danger">
                            <div className="card-block pb-0">
                                <div className="btn-group float-right">
                                    <Dropdown isOpen={this.state.card4} toggle={() => { this.setState({ card4: !this.state.card4 }); }}>
                                        <button onClick={() => { this.setState({ card4: !this.state.card4 }); }} className="btn btn-transparent active dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.card4}>
                                            <i className="icon-settings"></i>
                                        </button>
                                        <DropdownMenu>
                                            <DropdownItem>Action</DropdownItem>
                                            <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                                <h4 className="mb-0" >80%</h4>
                                <p >Gestion</p>
                            </div>
                            <div className="chart-wrapper px-3">
                                <Bar data={cardChartData4} options={cardChartOpts4} height={70} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-sm-5">
                                <h4 className="card-title mb-0">Cumplimiento de visitas planificadas</h4>
                                <div className="small text-muted">{this.state.meses[this.state.mes] +" "+ this.state.año }</div>
                            </div>
                            <div className="col-sm-7 hidden-sm-down">
                                <button type="button" className="btn btn-primary float-right"><i className="icon-cloud-download"></i></button>
                                <div className="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                                    <div className="btn-group mr-3" data-toggle="buttons" aria-label="First group">
                                        <label className="btn btn-outline-secondary">
                                            <input type="radio" name="options" id="option1" /> Día
                    </label>
                                        <label className="btn btn-outline-secondary active">
                                            <input type="radio" name="options" id="option2" defaultChecked /> Mes
                    </label>
                                        <label className="btn btn-outline-secondary">
                                            <input type="radio" name="options" id="option3" /> Año
                    </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="chart-wrapper" style={{ height: 300 + 'px', marginTop: 40 + 'px' }}>
                            <Line data={mainChart} options={mainChartOpts} height={300} />
                        </div>
                    </div>
                    <div className="card-footer">
                        <ul>
                            <li>
                                <div className="text-muted" ># Locales</div>
                                <strong >585</strong>
                                <Progress className="progress-xs mt-2" color="success" value="40" />
                            </li>
                            <li className="hidden-sm-down">
                                <div className="text-muted" ># Productos</div>
                                <strong >1286</strong>
                                <Progress className="progress-xs mt-2" color="info" value="20" />
                            </li>
                            <li>
                                <div className="text-muted" ># Visitas</div>
                                <strong >532</strong>
                                <Progress className="progress-xs mt-2" color="warning" value="60" />
                            </li>
                            <li className="hidden-sm-down">
                                <div className="text-muted" >Gestion</div>
                                <strong >80%</strong>
                                <Progress className="progress-xs mt-2" color="danger" value="80" />
                            </li>
                            <li className="hidden-sm-down">
                                <div className="text-muted" >Perdida venta</div>
                                <strong  >184M</strong>
                                <Progress className="progress-xs mt-2" color="primary" value="40" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default MockUp;



// WEBPACK FOOTER //
// ./src/views/dashBoard/mockUp.js